/* __next_internal_client_entry_do_not_use__ default auto */ import * as React from 'react';
const usePreviousProps = (value)=>{
    const ref = React.useRef({});
    React.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
export default usePreviousProps;
